@if (layout === 'product') {
    <header class="product-header is-product">
        @if (config.image) {
            <sirius-image-item class="product-image" [image]="config.image" [imageData]="imageData" [autocrop]="false">
            </sirius-image-item>
        }
        <sirius-heading [text]="config.title" textStyleCategory="title" textStyleSize="m" [h]="3"></sirius-heading>
    </header>
}

@if (layout === 'series') {
    <header class="product-header is-series">
        <div>
            <sirius-heading [text]="config.title" textStyleCategory="display" textStyleSize="s" [h]="3"></sirius-heading>
            @if (config.subtitle) {
                <p class="sir-text-style-paragraph-m-default">{{ config.subtitle }}</p>
            }
        </div>
        @if (config.tags?.length) {
            <ul class="product-tags" aria-label="Tags">
                @for (tag of config.tags; track tag.text) {
                    <li><sirius-chip [config]="tag"></sirius-chip></li>
                }
            </ul>
        }
    </header>
}

<ol class="product-specs" aria-label="Product properties" data-cy="product-information-tags">
    @for (prop of config.properties; track prop.name) {
        <li class="product-spec">
            <span class="sir-text-style-system-s-bold sir-text-style-color-secondary">{{
                prop.name
            }}</span>
            <span class="sir-text-style-system-l-bold sir-text-style-color-primary">{{
                prop.value
            }}</span>
        </li>
    }
</ol>

<footer class="product-action">
    <a
        siriusButton
        [siriusLink]="config.button.link"
        [iconName]="config.button.iconName"
        [buttonText]="config.button.link.title"
        buttonType="primary"
        data-cy="product-information-button">
    </a>
</footer>
